import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ISemesterNotificationContext } from '@lb/api/mylb/interfaces';
import { NotificationBaseComponent } from './notification-base/notification-base.component';

/**
 * Instructor notification: a semester is complete and its final grade is still pending submission.
 * `data` is the hydrated SemesterNotificationContext; EntityID is the SemesterID.
 *
 * The backend auto-dismisses this notification once grades are submitted (SemesterGradesSubmittedEvent);
 * the action navigates the instructor to the enrollment overview to submit the grade there.
 */
@Component({
	standalone: true,
	imports: [CommonModule, NotificationBaseComponent],
	selector: 'lb-notification-final-grade-required',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>
			Final grades are due for <b>Semester {{ context()?.levelName }}</b
			>.
		</div>
		<div activity-action>
			@if (context()) {
				<button type="button" md-button (click)="submitGrades()">Submit Grades</button>
			}
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationFinalGradeRequiredComponent extends NotificationBaseComponent {
	private readonly _router = inject(Router);

	context = computed(() => this.notification().data as ISemesterNotificationContext);

	submitGrades(): void {
		const context = this.context();
		if (!context) {
			return;
		}

		this._router.navigate(['/enrollments', context.enrollmentID]);
	}
}
